import { useMemo } from 'react';

let idCounter = 0;
const useUniqueId = () => {
    const id = useMemo(() => idCounter++, []);
    return `${id}`;
};

export { useUniqueId };
//# sourceMappingURL=useUniqueId.esm.js.map
